/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { APP_CONFIG as CORE_APP_CONFIG } from '@core/config/app-config';
import { AppConfigModel } from '@models/app/app-config.model';

export const APP_CONFIG: AppConfigModel = {
  ...CORE_APP_CONFIG,
  generic: {
    ...CORE_APP_CONFIG.generic,
    errorDisplay: 'complete',
    sendLogs: true
  },
  theme: {
    logoUrl: 'assets/icons/logo_banca.svg',
    activeViews: [
      ['DOCS_REQ_PREFACE', true],
      ['QUO_PREV_STD', true]
    ]
  },
  form: {
    searchInterface: 'modal',
    selectInterface: 'action-sheet'
  },
  survey: {
    alertWhenContinue: true,
    searchInterface: 'modal',
    selectInterface: 'action-sheet'
  },
  quotation: {
    primaryData: [
      {
        id: 'netDisbursedAmountToCustomer',
        title: 'lbl.amount_paid',
        format: 'currency'
      },
      {
        id: 'montante',
        title: 'lbl.riser',
        format: 'currency'
      },
      {
        id: 'interessi',
        title: 'lbl.interests',
        format: 'currency'
      },
      {
        id: 'installment',
        title: 'lbl.installment',
        format: 'currency'
      },
      {
        id: 'duration',
        title: 'lbl.quotation_duration',
        format: 'month'
      },
      { id: 'tan', title: 'lbl.quotation_tan', format: 'perc' },
      { id: 'taeg', title: 'lbl.quotation_taeg', format: 'perc', bold: true }
    ],
    moduleCodes: ['comm-offer', 'pre-contr', 'pre-contr-insurance'],
    moduleCodesToMark: ['comm-offer', 'pre-contr', 'pre-contr-insurance'],
    moduleCodesToView: ['comm-offer', 'pre-contr', 'pre-contr-insurance']
  },
  wizard: {
    ...CORE_APP_CONFIG.wizard,
    freeNavigation: false,
    dummyWizards: {
      ['WEB_RIC_DOC']: {
        wizardCode: 'SELF-ADDRIC-DOC',
        status: 0,
        steps: []
      },
      ['CQS_LET_DIN']: {
        wizardCode: 'SELF-VIEW-DOC',
        status: 0,
        steps: []
      }
    }
  },
  upload: {
    ...CORE_APP_CONFIG.upload,
    uploadSorting: [
      'DOC_IDE_WEBAPP', // documenti d'identità
      'DOC_IDE', // documenti d'identità
      'B03.1', // cartà identità
      'B03.2', // passaporto
      'B03.3', // patente
      'DI_AGG', // altri documenti d'identità
      'F22', // autocertificazione residenza
      'B05', // permesso di soggiorno
      'B04', // codice fiscale
      'DOC_RED', // documenti reddituali
      'B07', // busta paga
      'B94', // cedolino
      'DOC_RED_PENS', // Doc. reddituali pensionati
      'B09', // obis
      'B95', // obis
      'F06' // CUD
    ],
    checkSorting: [
      'B04', // codice fiscale
      'DOC_IDE_WEBAPP', // documenti d'identità
      'DOC_IDE', // documenti d'identità
      'B03.1', // cartà identità
      'B03.2', // passaporto
      'B03.3', // patente
      'DI_AGG', // altri documenti d'identità
      'F22', // autocertificazione residenza
      'B05', // permesso di soggiorno
      'DOC_RED', // documenti reddituali
      'B07', // busta paga
      'B94', // cedolino
      'DOC_RED_PENS', // Doc. reddituali pensionati
      'B09', // obis
      'B95', // obis
      'F06' // CUD
    ],
    documentPages: {
      ['B03.1']: 'front|back',
      ['B03.3']: 'front|back',
      ['B04']: 'front|back',
      ['CIE']: 'front|back'
    },
    additionalPages: {
      ['F22']: 20,
      ['B05']: 20,
      ['B07']: 20,
      ['B94']: 20,
      ['B09']: 20,
      ['B95']: 20,
      ['F06']: 20
    },
    avoidInstructions: true
  },
  documentsRequest: {
    ...CORE_APP_CONFIG.documentsRequest,
    additionalRequestOperationCodes: ['WEB_RIC_DOC'],
    ignoreMandatoryFor: true
  }
};
